import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _reactGA4 from 'react-ga4';
import { ANALYTICS_ENABLED } from '../utils/analytics';

// Handles CJS/ESM interop: Rolldown production bundler may double-wrap the default export
const reactGA4 =
  (_reactGA4 as unknown as { default: typeof _reactGA4 })?.default ?? _reactGA4;

export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (!ANALYTICS_ENABLED) return;
    if (location.pathname === '/') return;
    reactGA4.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]);
};
